<template>
  <div class="industries">
    <div class="scrollbar">
      <div
        v-for="industry in industries"
        :key="'industry-' + industry.id"
        :class="{'selected': selected && industry.id === selected.id}"
        class="industry"
        @click="selectIndustry(industry)">
        <div class="title">
          {{ industry.name }}
        </div>
        <span class="edit-industry">
          <svg-icon name="edit" @click="edit(industry)" />
          <span class="delete-industry"><i @click="deleteFunc(industry)" class="el-icon-delete"></i></span>
        </span>
    </div></div>
    <div class="buttons">
      <el-button type="warning" round @click="create">
        {{ $t('create') }}
      </el-button>
    </div>

    <el-dialog
      :title="form.id ? $t('editIndustry') : $t('addIndustry')"
      :visible.sync="showForm"
      :modal-append-to-body="false"
    >
      <el-form ref="hunterForm" class="industry-modal">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('name')" prop="name">
              <el-input v-model="form.name" type="text" autocomplete="off" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="cancel">
          {{ $t('cancel') }}
        </el-button>
        <el-button type="warning" round @click="save">
          {{ form.id ? $t('save') : $t('add') }}
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="deleteForm"
      :modal-append-to-body="false"
    >
    <el-row>
      {{ $t('deleteServiceIndustry') }}
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="text" @click="cancel">
        {{ $t('cancel') }}
      </el-button>
      <el-button type="warning" round @click="deleteIndustryFunc">
        {{ form.id ? $t('delete') : $t('delete') }}
      </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import { getIndustries, createIndustry, deleteIndustry } from '@/api/industries'

  export default {
    props: {
      selected: Object
    },

    data() {
      return {
        industries: [],
        showForm: false,
        deleteForm: false,
        form: {
          id: null,
          termId: null,
          name: ''
        }
      }
    },

    created() {
      this.getList()
    },

    methods: {
      async getList() {
        const { data } = await getIndustries()
        this.industries = data.data
        this.selectIndustry(this.industries[0])
      },

      selectIndustry(industry) {
        this.$emit('industry-change', industry)
      },

      create() {
        this.resetForm()
        this.showForm = true
      },

      cancel() {
        this.resetForm()
      },
      resetForm() {
        this.form.id = null
        this.form.name = ''
        this.showForm = false
        this.deleteForm = false
      },
      save() {
        if (this.form.id) {
          this.update()
        } else {
          this.store()
        }
      },
      async store() {
        const payloadObj = {
          name: this.form.name
        }
        createIndustry(payloadObj)
          .then(() => {
            this.resetForm()
            this.getList()
          })
      },
      async update() {
        const payloadObj = {
          id: this.form.id,
          name: this.form.name
        }
        createIndustry(payloadObj)
          .then(() => {
            this.resetForm()
            this.getList()
          })
      },
      edit(industry) {
        this.form.id = industry.term_id
        this.form.name = industry.name
        this.showForm = true
      },
      deleteFunc(industry) {
        this.form.id = industry.id
        this.form.termId = industry.term_id
        this.showForm = false
        this.deleteForm = true
      },
      deleteIndustryFunc() {
        this.deleteIndustry()
      },
      async deleteIndustry() {
        const payloadObj = {
          id: this.form.id,
          termId: this.form.termId
        }
        deleteIndustry(payloadObj)
        .then(() => {
          this.resetForm()
          this.getList()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/variables';

  .industries {
    position: absolute;
    top: 30px;
    left: 0;
    bottom: 30px;
    width: 98%;
    //z-index: 500;;

    .scrollbar {
      height: 95%;
    }

    .industry {
      position: relative;
      border-bottom: 1px solid $border-color-light;
      padding: 32px 0;
      font-weight: 500;
      font-size: 20px;
      line-height: 33px;
      cursor: pointer;
      color: $color-text-regular;

      &.selected {
        font-weight: bold;
        color: $color-primary
      }
    }

    .edit-industry {
      right: 0;
      top: 30px;
      position:absolute;
      cursor: pointer;
    }

    .edit-industry .svg-icon{
      height: 16px;
      width: 18px;
    }

    .edit-industry .delete-industry{
      margin-left: 10px;
    }
  }
</style>
